import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import TitleSelect from '@ertelecom/ui-react/components/select/titleSelect';

export const Select = styled(TitleSelect)`
    top: 2px;
`;

export const Card = styled.div`
    max-height: 540px;
    min-height: 511px;
    height: 55vh;
    min-width: 100%;
    border: 1px solid ${COLORS.outlineGrey};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: nowrap;
    padding: 10px 24px 10px 24px;
    background: ${COLORS.white};
    z-index: 3;
`;

export const Pic = styled.div`
    height: 30%;
    width: 100%;
    background: ${props => props.background} center no-repeat;
    background-size: contain;
    background-position: center;
`;

export const Type = styled.p`
    ${FONTS.XS};
    color: ${COLORS.darkGrey};
`;

export const Free = styled.p`
    display: flex;
    flex-direction: row;
    ${FONTS.XS};
    color: ${COLORS.darkGrey};
    margin-bottom: 3px;
`;

export const Title = styled.p`
    position: relative;
    ${FONTS.M};
    color: ${COLORS.black};
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 2;
    &:hover {
        overflow: visible;
        white-space: normal;
    }
    @media (max-width: 530px) {
        ${FONTS.S};
    }
`;

export const Description = styled.div`
    height: 30%;
    width: 100%;
    ${FONTS.XS};
    white-space: pre-wrap;
    overflow: hidden;
    margin-bottom: 5px;
    color: ${COLORS.darkGrey};
    @media (max-width: 713px) {
        ${FONTS.XXS};
    }
    @media (max-width: 690px) {
        ${FONTS.XS};
    }
    @media (max-width: 350px) {
        ${FONTS.XXS};
    }
`;

export const WrapperPrice = styled.div`
    display: flex;
    flex-direction: column;
    align-items: left;
    margin-bottom: 5px;
    height: 50px;
    justify-content: flex-end;
`;

export const PriceText = styled.p`
    ${FONTS.XS};
    display: inline;
    margin-right: 10px;
    padding-top: 3px;
`;

export const Price = styled.p`
    ${FONTS.L};
    margin-right: 5px;
    color: ${COLORS.black};
`;

export const Button = styled(StyledButton)`
    width: 100%;
    height: 48px;  
    margin-bottom: 15px; 
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const Discount = styled.div`
    padding-top: 1px;
    margin-left: 5px;
    width: 46px;
    height: 20px;
    border-radius: 11px;
    ${FONTS.XS};
    justify-content: center;
    text-decoration: none;
    background: ${COLORS.red};
    color: ${COLORS.white};
`;
